import api from '@services/api'

export default {
  load(axios, params, payload, config) {
    return api.post(axios, '/utils/i18n', params, payload, { ...config, isBackground: true })
  },
}
